import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import { Box, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import TicketsContainer from "@jumbo/Dashboards/TicketsContainer";

import { useSelector,useDispatch } from "react-redux";
import { setTicketsStatus } from "redux/actions/Tickets";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.tickets"} />, isActive: true },
];

const Tickets = () => {
  const dispatch = useDispatch();
  const { ticketsStatus } = useSelector(({ tickets }) => tickets);

  return (
    <PageContainer
      heading={<IntlMessages id="pages.tickets" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            marginBottom={"10px"}
          >
            <div>
              <IntlMessages id="pages.tickets.description" />
            </div>
            <FormControl variant="outlined" style={{width:'250px'}} >
              <InputLabel id="demo-simple-select-outlined-label">
                وضعیت
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={ticketsStatus}
                onChange={(e) => dispatch(setTicketsStatus(e.target.value))}
                label="status"
              >
                <MenuItem value={"WaitingForResponse"}>منتظر پاسخ گویی</MenuItem>
                <MenuItem value={"Responded"}>پاسخ داده شده</MenuItem>
                <MenuItem value={"All"}>همه موارد</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Divider />
          <div style={{ marginTop: 24 }}>
            <TicketsContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Tickets;